/**
 * Formatting for Lease Liability – Ind AS output dialogs: Indian digit grouping (e.g. 1,00,000).
 * Numbers are shown as whole amounts (no decimals) except "Discounting Factor", which uses 2 decimal places.
 */
const DISCOUNTING_FACTOR_HEADER = "Discounting Factor";

function parseFiniteNumber(value: unknown): number | null {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (/^-?\d+(\.\d+)?([eE][+-]?\d+)?$/.test(trimmed)) {
      const n = Number(trimmed);
      return Number.isFinite(n) ? n : null;
    }
  }
  return null;
}

/** Round to integer; Indian grouping, no decimal part. */
function formatIntegerIndian(n: number): string {
  return Math.round(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

/** Exactly 2 decimal places; Indian grouping. */
function formatDiscountingFactorIndian(n: number): string {
  const rounded = Math.round(n * 100) / 100;
  return rounded.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * @param columnHeader — table column key; "Discounting Factor" keeps 2 decimal places; all other numbers are whole.
 */
export function formatLeaseDialogCell(value: unknown, columnHeader?: string): string {
  if (Array.isArray(value)) {
    return value.map((item) => formatLeaseDialogCell(item, undefined)).join(",");
  }

  const isDiscounting = columnHeader?.trim() === DISCOUNTING_FACTOR_HEADER;
  const n = parseFiniteNumber(value);
  if (n !== null) {
    return isDiscounting ? formatDiscountingFactorIndian(n) : formatIntegerIndian(n);
  }

  if (typeof value === "string") return value;
  if (value === null || value === undefined) return "";
  return String(value);
}
